import { dataUrltoBlob, getDimensions, resize } from '../../../utils/image'

export const maxScreenshotSide = 2000
export const maxUnconvertedBytes = 5000000

// Legacy's rule: anything larger than 2000 px a side, over 5 MB or not a JPEG goes up as a JPEG.
export const needsScreenshotConversion = (file: File, { width, height }: { width: number; height: number }) =>
  width > maxScreenshotSide || height > maxScreenshotSide || file.size > maxUnconvertedBytes || file.type !== 'image/jpeg'

export const toJpegName = (name: string) => `${name.replace(/\.[^./]+$/, '')}.jpg`

export const toScreenshotUploadFile = async (file: File) => {
  const dimensions = await getDimensions(file)
  if (!needsScreenshotConversion(file, dimensions)) return file
  const dataUrl = await resize(file, { width: maxScreenshotSide, height: maxScreenshotSide, quality: 0.9, mimeType: 'image/jpeg' })
  return new File([dataUrltoBlob(dataUrl)], toJpegName(file.name), { type: 'image/jpeg' })
}

// As legacy's upload table: kB under 500,000 bytes, MB from there, in units of 1,000.
export const formatFileSize = (bytes: number) => (bytes < 500000 ? `${(bytes / 1000).toFixed(2)} kB` : `${(bytes / 1000000).toFixed(2)} MB`)
